import JSZip from 'jszip';
import { TEMPLATE_ITEMS, templateUrl } from './tvecTemplates';
import { ALL_COURSES_ID, COURSE_PROGRAMMES } from './tvecCourse';

// "Download all" for the course chosen in the top bar.
//   one course  -> that course's documents
//   all courses -> every course plus the common material
// The typed-from-pasted-text formats are not included: they are not originals.
// Files go into the ZIP unchanged, in the same folder layout as the supplied TEVC folder:
//   HND Computing (TVEC)/Lesson Plan/Sem 1/Session_Plan - DDD.xlsx
export function itemsForDownload(course) {
  if (course.id === ALL_COURSES_ID) {
    const wanted = new Set([...COURSE_PROGRAMMES.map((c) => c.id), 'common']);
    return TEMPLATE_ITEMS.filter((it) => wanted.has(it.programme));
  }
  return TEMPLATE_ITEMS.filter((it) => it.programme === course.id);
}

const safeName = (text) => text.replace(/[^A-Za-z0-9]+/g, '_').replace(/^_+|_+$/g, '');
export const zipNameFor = (course) => `TVEC_Templates_${safeName(course.short || course.label)}.zip`;

const zipPathOf = (item) => item.urlPath.replace(/^originals\//, '');

// Fetches the files a few at a time and returns the ZIP as a Blob.
export async function buildTemplatesZip(items, onProgress) {
  const zip = new JSZip();
  let done = 0;
  const failed = [];
  const queue = [...items];

  const worker = async () => {
    for (;;) {
      const item = queue.shift();
      if (!item) return;
      try {
        const res = await fetch(templateUrl(item));
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        zip.file(zipPathOf(item), await res.arrayBuffer(), { binary: true });
      } catch (err) {
        failed.push(item.file);
      }
      done += 1;
      if (onProgress) onProgress(done, items.length);
    }
  };
  await Promise.all(Array.from({ length: Math.min(6, items.length) }, worker));

  // Never hand over a silently incomplete ZIP.
  if (failed.length) {
    const error = new Error(`${failed.length} file(s) could not be downloaded`);
    error.failed = failed;
    throw error;
  }
  // Word / Excel / PDF files are already compressed, so store them as they are.
  return zip.generateAsync({ type: 'blob', compression: 'STORE' });
}

export function saveBlob(blob, fileName) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = fileName;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  setTimeout(() => URL.revokeObjectURL(url), 10000);
}
